export const DRAFT_STATUS = "draft";
export const SENT_STATUS = "sent";
export const UNDER_REVIEW_STATUS = "under_review";
export const ACCEPTED_STATUS = "accepted";
export const DECLINED_STATUS = "declined";
export const SCHEDULED_STATUS = "scheduled";
export const REC_COMPLETED_STATUS = "rec_completed";
export const REF_COMPLETED_STATUS = "ref_completed";
export const COMPLETED_STATUS = "completed";
export const FAXED_SUCCESSFULLY_STATUS = "faxed_successfully";
export const SENDING_FAX_STATUS = "sending_fax";
export const PENDING_APPROVAL_STATUS = "pending_approval";
export const MANUALLY_CREATED_STATUS = "manually_created";

export const REFERRAL_STATUSES = [
  DRAFT_STATUS,
  SENT_STATUS,
  UNDER_REVIEW_STATUS,
  ACCEPTED_STATUS,
  DECLINED_STATUS,
  SCHEDULED_STATUS,
  REC_COMPLETED_STATUS,
  REF_COMPLETED_STATUS,
  COMPLETED_STATUS,
  FAXED_SUCCESSFULLY_STATUS,
  SENDING_FAX_STATUS,
  PENDING_APPROVAL_STATUS,
  MANUALLY_CREATED_STATUS
];
